const backToTopURL =
  "https://static.igem.wiki/teams/4380/wiki/backtotop/back-to-top.svg"

export default backToTopURL
